import React, { useEffect, useState } from 'react'
import Navbar from '../components/Sidebar'
import Header from '../components/HeaderCar'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import CalendarData from '../components/Calendar.json'
import Spinner from '../components/Spinner'
import $ from 'jquery'
import '@popperjs/core'
import { Tooltip } from 'bootstrap'


export default function Calendar() {
    const [loading, setLoading] = useState(true);
    const [calendarEvents, setCalendarEvents] = useState([]);

    const initData = function () {
        var res = [];
        for (let i = 0; i < CalendarData.length; i++) {
            res.push({
                title: CalendarData[i].title,
                start: CalendarData[i].start,
                end: CalendarData[i].end,
                url: '/ViewEvent/' + CalendarData[i].id,
                mouseEnterInfo: CalendarData[i].title
            })
        }
        console.log(res);
        setCalendarEvents(res);
        setLoading(false);
    }

    useEffect(() => {
        initData();
    }, []);


    return (
        <div>

            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container'>
                    <div className='row'>
                        <h3>Community Calendar</h3>
                    </div>
                    <div className='row mb-3'>
                        {
                            (loading) ? (<Spinner padding={5} />) : (
                                <FullCalendar
                                    plugins={[dayGridPlugin]}
                                    initialView="dayGridMonth"
                                    events={calendarEvents}
                                    eventDidMount={(info) => {
                                        var el = new Tooltip(info.el, {
                                            title: info.event.title,
                                            placement: "right",
                                            trigger: "hover"
                                        })
                                    }}
                                />
                            )
                        }
                    </div>
                </div>
            </main>


        </div>
    )
}
